import { IntegrationIcon } from '../../components/IntegrationIcon'
import { IntegrationServiceId } from '../../common/integrations'
import { ReactComponent as ZoomPhoneIcon } from '../../assets/images/integration-logos/color/zoom-phone-outline.svg'

export const RingCentralIconComponent = () => (
  <IntegrationIcon width={16} height={16} fill='var(--zocks-gray-900)' serviceId={IntegrationServiceId.RINGCENTRAL} />
)

export const GotoIconComponent = () => <IntegrationIcon width={16} height={16} fill='currentColor' serviceId={IntegrationServiceId.GOTO} />

export const ZoomPhoneIconComponent = () => <ZoomPhoneIcon width={19} height={19} className='flex-shrink-0' />
